import React, { memo } from 'react';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { Typography, Stack } from '@mui/material';
import utils from 'components/utils';
import moment from 'moment';

const WishlistInfoComp = ({ id, isDefault, name, type, lastUpdate, special, status, eventDate }) => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const titleStyle = type === 'BOOK2C' ? { color: 'rgba(57,172,233,255)' } : {};

	const WLType = [
		{ id: 0, label: translate('wishlistSpecial.typeAdozione'), value: 'ADOZIONE' },
		{ id: 1, label: translate('wishlistSpecial.typeFestival'), value: 'FESTIVAL' },
		{ id: 2, label: translate('wishlistSpecial.typePresentazione'), value: 'PRESENTAZIONE' }
	];

	const getSpecialTypeDesc = (type, data) => {
		const tipo = WLType.filter(item => item.value === type);
		if (tipo.length > 0) return ' (' + tipo[0].label + ':' + moment(data).format('L') + ')';
		return '';
	};

	const eventInfo = special ? getSpecialTypeDesc(type, eventDate) : '';

	return (
		<Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
			<Typography
				variant="subtitle2"
				sx={{
					color:
						type === 'BOOK2C'
							? theme.palette.custom.book2c
							: special &&
							  (status === 'INITIAL' ||
									status === 'DRAFT_AGENT' ||
									status === 'NO_EX_CON' ||
									status === 'REFUSED')
							? theme.palette.custom.greenlight
							: theme.palette.primary.black
				}}
			>
				{!isDefault ? name : translate('orders.defaultCart')}
			</Typography>

			<Typography variant="body2">{moment(lastUpdate).format('L') + eventInfo}</Typography>
		</Stack>
	);
};

const WishlistInfo = memo(
	({ item }) => (
		<WishlistInfoComp
			id={item.id}
			isDefault={item.isDefault}
			name={item.name}
			type={item.type}
			lastUpdate={item.lastModifiedDate}
			special={item.special}
			status={item.status}
			eventDate={item.eventDate}
		/>
	),
	(p, n) =>
		p.item.id === n.item.id &&
		p.item.isDefault === n.item.isDefault &&
		p.item.name === n.item.name &&
		p.item.type === n.item.type &&
		p.item.lastModifiedDate === n.item.lastModifiedDate &&
		p.item.special === n.item.special &&
		p.item.status === n.item.status &&
		p.item.eventDate === n.item.eventDate
);

export default WishlistInfo;
